"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentWithDatasheetUrlInFluxArray = exports.DocumentWithDatasheetUrlInFlux = exports.LcscDocumentWithDatasheetUrlArray = exports.LcscDocumentWithDatasheetUrl = exports.StoredAsset = exports.acceptedAssetFileTypes = void 0;
const zod_1 = require("zod");
exports.acceptedAssetFileTypes = [
    "svg",
    "png",
    "glb",
    "jpg",
    "jpeg",
    "kicad_mod",
    "mod",
    "pcblib",
    "dxf",
    "step",
    "stp",
    "gltf",
    "flx_ftp",
];
/**
 * Assets are a pretty flat data structure already - it's just a bunch of primitives stuck
 * together.  So the asset data is stored as more or less a straight translation of the in-memory
 * data structure.
 */
exports.StoredAsset = zod_1.z.object({
    uid: zod_1.z.string(),
    userCodeData: zod_1.z.optional(zod_1.z.any()),
    name: zod_1.z.string(),
    rawName: zod_1.z.string(),
    storageName: zod_1.z.string(),
    label: zod_1.z.string(),
    fileType: zod_1.z.enum(exports.acceptedAssetFileTypes),
    isDefault: zod_1.z.boolean(),
    associatedSymbol: zod_1.z.optional(zod_1.z.string()),
    isThumbnail: zod_1.z.boolean(),
    isFootprint: zod_1.z.boolean(),
    is3dModel: zod_1.z.boolean(),
    isPcbBoardShape: zod_1.z.boolean(),
});
exports.LcscDocumentWithDatasheetUrl = zod_1.z.custom();
exports.LcscDocumentWithDatasheetUrlArray = zod_1.z.array(exports.LcscDocumentWithDatasheetUrl);
exports.DocumentWithDatasheetUrlInFlux = zod_1.z.custom();
exports.DocumentWithDatasheetUrlInFluxArray = zod_1.z.array(exports.DocumentWithDatasheetUrlInFlux);
//# sourceMappingURL=asset.js.map